module.exports = __webpack_public_path__ + "img/efficacy.8d5a018e.png";